export enum CSSVarType {
    Color,
    Font,
    FontSize
}
